import { useCallback, useState, useEffect } from 'react';
import { SortObject, SortModeEnum } from 'components/filtering/types/SortObject';



export const useGridSorting = <T extends object>(originData: Array<T> | undefined | null) => {

	const [ sortedData, setSortedData ] = useState<Array<T> | null>(null);
	const [ sortObject, setSortObject ] = useState<SortObject<T> | null>(null);

	useEffect(() => {
		if (!originData) {
			setSortedData(null);
			return;
		}
		if (!sortObject) {
			setSortedData(originData);
			return;
		}
		if (sortObject && sortObject.mode === SortModeEnum.asc) {
			let sorted = originData.toSorted((a,b) => {
				let property = sortObject.property;

				if (a[property] === undefined && b[property] === undefined) return 0;
				if (a[property] === null && b[property] === null) return 0;

				if (a[property] === undefined && b[property] !== undefined) return -1;
				if (a[property] === null && b[property] !== null) return -1;

				if (a[property] !== undefined && b[property] === undefined) return 1;
				if (a[property] !== null && b[property] === null) return 1;

				if (a[property] === b[property]) return 0;
				if (a[property] > b[property]) return 1;
				if (a[property] < b[property]) return -1;
				return 0;
			});
			setSortedData(sorted);
			return;
		};
		if (sortObject && sortObject.mode === SortModeEnum.desc) {
			let sorted = originData.toSorted((a,b) => {
				let property = sortObject.property;

				if (a[property] === undefined && b[property] === undefined) return 0;
				if (a[property] === null && b[property] === null) return 0;

				if (a[property] === undefined && b[property] !== undefined) return 1;
				if (a[property] === null && b[property] !== null) return 1;

				if (a[property] !== undefined && b[property] === undefined) return -1;
				if (a[property] !== null && b[property] === null) return -1;

				if (a[property] === b[property]) return 0;
				if (a[property] > b[property]) return -1;
				if (a[property] < b[property]) return 1;
				return 0;
			});
			setSortedData(sorted);
			return;
		};
	}, [ originData, sortObject ]);


	const handleSorting = useCallback((property: keyof T, mode: SortModeEnum) => {
		if (sortObject && sortObject.property === property && sortObject.mode === mode) {
			setSortObject(null);
			return;
		};
		let newSortObject: SortObject<T> = { property, mode };
		setSortObject(newSortObject);
	},[ sortObject ]);


	const clearSorting = useCallback((property: keyof T) => {
		if (sortObject && sortObject.property === property) {
			setSortObject(null);
		};
	},[ sortObject ]);


	return [ sortedData, sortObject, handleSorting, clearSorting ] as const;
};